import { getEnv } from '../utils/env';

/** Public site URL for canonical, Open Graph, and Twitter cards (no trailing slash). */
export const SITE_URL = getEnv('SITE_URL', 'https://pluxinfosystems.com').replace(/\/$/, '');

export const SITE_NAME = 'Plux Infosystems';

export const DEFAULT_OG_IMAGE_PATH = '/img/webdevelopment.png';

/** Default when a page does not pass custom `keywords`. */
export const DEFAULT_KEYWORDS =
  'web development company, product engineering agency, React development, Magento developer, WordPress agency, AI automation, website maintenance, ecommerce development, global software partner, Plux Infosystems';

export const TWITTER_HANDLE = '@chandra353';
